/**
 * One accent for every «Поделиться» affordance on the gamification surfaces.
 *
 * They all used to paint with `colors.solar` (#E98245) — the same muted orange
 * as body accents — so on the painted «Путь Света» cards the triggers read as
 * decoration rather than controls. This is deliberately brighter than solar:
 * a deeper, more saturated orange on light backgrounds and a lighter one on
 * dark, both at AA contrast against their card.
 *
 * The tint is the disc behind a bare icon: it is what turns a lone glyph into
 * something that looks pressable.
 */
export const SHARE_ACCENT = { light: '#DE6A11', dark: '#FFA24D' } as const;
export const SHARE_ACCENT_TINT = {
  light: 'rgba(222,106,17,0.14)',
  dark: 'rgba(255,162,77,0.20)',
} as const;

export const shareAccent = (isDark: boolean): string =>
  (isDark ? SHARE_ACCENT.dark : SHARE_ACCENT.light);

export const shareAccentTint = (isDark: boolean): string =>
  (isDark ? SHARE_ACCENT_TINT.dark : SHARE_ACCENT_TINT.light);
